// extracted by mini-css-extract-plugin
export default {"starredFileList":"Starred_starredFileList__Wacux","noFileMessage":"Starred_noFileMessage__G3Vbr"};